import React from 'react';

function CheckIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="26"
      height="26"
      viewBox="-263.5 236.5 26 26"
    >
      <g className="svg-success">
        <circle cx="-250.5" cy="249.5" r="12" />
        <path d="M-256.46 249.65l3.9 3.74 8.02-7.8" />
      </g>
    </svg>
  );
}

export default CheckIcon;
